import { render, staticRenderFns } from "./customerSupplierSelect.vue?vue&type=template&id=05e53f8a&"
import script from "./customerSupplierSelect.vue?vue&type=script&lang=js&"
export * from "./customerSupplierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports